import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { connect } from "react-redux";

import actions from "@/actions";
import { getInformationMessageByMode } from "@/sagas/map/change-mode";

const MESSAGE =
    "Drag and drop selected lights around the map, use toolbar actions, or bulk edit properties.";

const TopBarSelectMode = ({
    changeMode,
    deselectAllLights,
    persistModeLights,
    selectType,
    pasteModeActivated,
    setInformation,
    anyLightSelected,
    onSelectTool,
    selectedTool,
}) => {
    const prevAnyLightSelectedRef = useRef(anyLightSelected);
    const prevSelectedToolRef = useRef(selectedTool);

    useEffect(() => {
        const autoClosePanels = ["move"];
        const prevAnyLightSelected = prevAnyLightSelectedRef.current;
        const prevSelectedTool = prevSelectedToolRef.current;

        if (!pasteModeActivated) {
            if (anyLightSelected && prevAnyLightSelected !== anyLightSelected) {
                setInformation(MESSAGE);
            } else if (!anyLightSelected && prevAnyLightSelected) {
                setInformation(
                    getInformationMessageByMode("select", selectType),
                );
                if (
                    prevSelectedTool &&
                    autoClosePanels.includes(prevSelectedTool.name)
                ) {
                    onSelectTool(null);
                }
            }
        }

        prevAnyLightSelectedRef.current = anyLightSelected;
        prevSelectedToolRef.current = selectedTool;
    }, [
        anyLightSelected,
        pasteModeActivated,
        selectType,
        setInformation,
        onSelectTool,
        selectedTool,
    ]);

    return (
        <div className="topBar">
            <div className="row">
                <div className="col-sm">
                    <p className="textTopbar"> Select Lights ({selectType})</p>
                </div>
                <div className="col-sm">
                    <div className="link" onClick={() => changeMode("view")}>
                        Cancel Select
                    </div>
                </div>
                <div className="col-sm d-flex align-items-center">
                    <button
                        type="button"
                        disabled={pasteModeActivated}
                        className="btn btn-primary array clear-selection"
                        onClick={deselectAllLights}
                    >
                        {`${selectType === "Rectangle" ? "Reset" : "Clear"} Selection`}
                    </button>
                </div>
                <div className="col-sm d-flex align-items-center justify-content-end me-2">
                    <button
                        type="button"
                        className="btn btn-dark done"
                        onClick={persistModeLights}
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

TopBarSelectMode.propTypes = {
    changeMode: PropTypes.func.isRequired,
    deselectAllLights: PropTypes.func.isRequired,
    persistModeLights: PropTypes.func.isRequired,
    selectType: PropTypes.string,
    pasteModeActivated: PropTypes.bool,
    information: PropTypes.string,
    setInformation: PropTypes.func.isRequired,
    anyLightSelected: PropTypes.bool,
    onSelectTool: PropTypes.func,
    selectedTool: PropTypes.any,
};

const mapStateToProps = ({ map, window }) => ({
    selectType: map.general.mode.props.type,
    anyLightSelected: map.general.selectedLights.length > 0,
    pasteModeActivated: map.general.pasteMode.activated,
    information: window.information,
    selectedTool: map.general.selectedTool,
});
const mapDispatchToProps = {
    changeMode: actions.map.general.changeMode,
    setInformation: actions.window.setInformation,
    deselectAllLights: actions.map.general.deselectAllLights,
    persistModeLights: actions.map.general.persistModeLights,
    onSelectTool: actions.map.general.selectTool,
};
export default connect(mapStateToProps, mapDispatchToProps)(TopBarSelectMode);
